import React, { useRef, useState, useEffect } from 'react';
import { convertTimestampMD, buildGradientString } from '../helpers/misc';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import * as CONFIG from '../config';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  windowDimensions: state.main.windowDimensions,
  timelinePixelsPerHour: state.app.timelinePixelsPerHour,
});

const TimelineLabel = props => {
  const {
    containerWidth,
    colorScheme,
    startTime,
    pixelsPerHour,
    windowDimensions,
    shiftsArr,
  } = props;
  const [showRulers, setShowRulers] = useState(false);
  const scrollingContainer = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => scrollingContainer.current.style.left = `-${window.pageXOffset}px`;
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleRulers = () => setShowRulers(!showRulers);
  const timeCellWidth = (windowDimensions.width - CONFIG.MACHINE_NAME_LABEL_WIDTH) / 4;
  const numberOfLabels = Math.floor((containerWidth - CONFIG.MACHINE_NAME_LABEL_WIDTH) / timeCellWidth);
  const timeInterval = Math.round((timeCellWidth / pixelsPerHour) * 3600000);
  const rulerHeight = windowDimensions.height ? windowDimensions.height - 150 : 0;
  const endTime = (timeInterval * ((containerWidth - CONFIG.MACHINE_NAME_LABEL_WIDTH) / timeCellWidth)) + startTime;
  const backgroundData = shiftsArr ? buildGradientString(startTime, endTime, shiftsArr, pixelsPerHour) : null;
  
  return (
    <div
      style={{
        ...styles.container,
        width: containerWidth,
        backgroundColor: GLOBAL_STYLES[colorScheme].bgColor,
        borderTopColor: GLOBAL_STYLES[colorScheme].fgColor,
      }}
    >
      <div
        style={styles.scrollingContainer}
        ref={scrollingContainer}
      >
        <div style={styles.viewRulersContainer}>
          <i
            onClick={toggleRulers}
            className={`fa ${showRulers ? 'fa-eye-slash' : 'fa-eye'} fa-2x`}
            style={styles.viewRulersButton}
          />
        </div>
        <div style={styles.timelineContainer}>
          <div style={styles.shiftContainer}>
            {
              backgroundData ?
                <svg width={backgroundData.totalWidth} height={20}>
                  {backgroundData.rectangles.map(({ color, x, width }, index) =>
                    <rect key={index} x={x} width={width} height={20} style={{ fill: color }}/>)}
                </svg> :
                null
            }
          </div>
          <div style={styles.labelContainer}>
            {Array.from(Array(numberOfLabels)).map((x, index) => (
              <div key={index} style={{ ...styles.timeCell, width: timeCellWidth }}>
                <div style={{ ...styles.verticalDivider, backgroundColor: GLOBAL_STYLES[colorScheme].fgColor }}/>
                <p style={styles.timeLabel}>{convertTimestampMD(startTime + (index * timeInterval))}</p>
                {
                  index !== 0 ?
                    <div
                      style={{
                        ...styles.verticalRuler,
                        height: rulerHeight,
                        minHeight: rulerHeight,
                        top: -rulerHeight - 60,
                        visibility: showRulers ? 'visible' : 'hidden',
                      }}
                    />
                    :
                    null
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};


const styles = {
  container: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: 60,
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    paddingRight: 10,
  },
  scrollingContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  timelineContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flexWrap: 'nowrap',
  },
  viewRulersContainer: {
    minWidth: CONFIG.MACHINE_NAME_LABEL_WIDTH - 1,
    width: CONFIG.MACHINE_NAME_LABEL_WIDTH - 1,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timeCell: {
    height: 60,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  verticalDivider: {
    width: 1,
    height: 30,
    minHeight: 30,
  },
  verticalRuler: {
    width: 1,
    boxSizing: 'border-box',
    borderLeftWidth: 1,
    borderLeftStyle: 'dashed',
    borderLeftColor: GLOBAL_STYLES.CONSTANTS.midGray,
    position: 'relative',
  },
  timeLabel: {
    margin: 0,
    padding: 0,
  },
  viewRulersButton: {
    cursor: 'pointer',
  },
  shiftContainer: {
    height: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: -20,
  }
};

export default connect(mapStateToProps)(TimelineLabel);
